// extracted by mini-css-extract-plugin
export var modulos = "PaquetePage-module--modulos--P4yyt";
export var reminderSection = "PaquetePage-module--reminder-section--gP6-o";